export * from '../src/auth-provider/index.js';
//# sourceMappingURL=auth-provider.js.map